import React, { Component } from 'react'
import JewelryPanel from '../jewelry-panel'
import SelectItem from '../../select-item'
import Spacer from '../../spacer'
import {
  showAdditionalOptionPanel
} from '../../../utils/jewelry-validation'

class AdditionalOptionPanel extends Component {
  render () {
    const props = this.props
    return (
      <JewelryPanel
        id='additionalOptionPanel'
        show={showAdditionalOptionPanel(props)}
        isResetting={props.isResetting}>

        <Spacer lg />

        <SelectItem
          id='additional_milgrain'
          label='Additional Milgrain'
          labelId='additional_milgrain'
          options={[
            {value: 'none', label: 'None'},
            {value: 'minor', label: 'Minor'},
            {value: 'major', label: 'Major'}
          ]}
          value={props.additional_milgrain}
          onChange={props.onChangeVal.bind(this, 'additional_milgrain')}
          initVal={null}
        />

        <Spacer xxs />

        <SelectItem
          id='hand_engraving'
          label='Hand Engraving'
          labelId='hand_engraving'
          options={[
            {value: 'none', label: 'None'},
            {value: 'minor', label: 'Minor'},
            {value: 'top_or_side', label: 'Top or Sides'},
            {value: 'top_and_side', label: 'Top and Sides'}
          ]}
          value={props.hand_engraving}
          onChange={props.onChangeVal.bind(this, 'hand_engraving')}
          initVal={null}
        />

        <Spacer xxs />

        <SelectItem
          id='special_finish'
          label='Special Finish'
          labelId='special_finish'
          options={[
            {value: 'none', label: 'None'},
            {value: 'satin_brushed', label: 'Satin/Brushed'},
            {value: 'matte', label: 'Matte'},
            {value: 'sandblast', label: 'Sandblast'},
            {value: 'hammer', label: 'Hammer'}
          ]}
          value={props.special_finish}
          onChange={props.onChangeVal.bind(this, 'special_finish')}
          initVal={null}
        />

      </JewelryPanel>
    )
  }
}

export default AdditionalOptionPanel



// WEBPACK FOOTER //
// ./src/components/jewelry-search-filters/additional-option-panel/index.js